export class LocalStorage {
    remove(key) {
        localStorage.removeItem(key);
    }

    add(key, value) {
        localStorage.setItem(key, value);
    }

    get(key) {
        return localStorage.getItem(key)
    }
}
